import React, { useState } from "react";
import CloseModalIcon from "../../assets/icons/CloseModalIcon";

const ShareBankDetailsModal = ({ onClose }) => {
  const [step, setStep] = useState("start"); // start | channel | whatsapp | email
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleSend = () => {
    if (step === "whatsapp") {
      const phoneRegex = /^\d{8}$/;
      if (!phoneRegex.test(phoneNumber)) {
        setPhoneNumberError("Phone number must be exactly 8 digits");
        return;
      }
      // Implement WhatsApp send logic here
      onClose();
    } else if (step === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        setEmailError("Please enter a valid email address");
        return;
      }
      // Implement email send logic here
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 relative w-[350px] min-h-[180px] shadow-lg flex flex-col justify-center items-center">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-[#B23B3B] hover:text-red-700"
          aria-label="Close"
        >
          <CloseModalIcon className="w-6 h-6" />
        </button>
        {step === "start" && (
          <button
            className="px-6 py-2 border border-gray-300 rounded-md text-[#959FA8] font-semibold text-base bg-[#F8F8F8] cursor-pointer"
            onClick={() => setStep("channel")}
          >
            Share Bank Details
          </button>
        )}
        {step === "channel" && (
          <div className="flex flex-col items-center w-full mt-2">
            <div className="text-center text-lg font-semibold text-[#959FA8] mb-6">
              Share bank details.<br />
              SMS only available.
            </div>
            <button
              className="w-[180px] py-2 border border-gray-300 rounded-md text-[#959FA8] font-semibold text-base bg-[#F8F8F8] hover:bg-gray-100 transition-colors"
              onClick={() => setStep("whatsapp")}
            >
              SMS
            </button>
            {/* <button
              className="w-[180px] mb-3 py-2 border border-gray-300 rounded-md text-[#959FA8] font-semibold text-base bg-[#F8F8F8] hover:bg-gray-100 transition-colors"
              onClick={() => setStep("whatsapp")}
            >
              WhatsApp
            </button>
            <button
              className="w-[180px] py-2 border border-gray-300 rounded-md text-[#959FA8] font-semibold text-base bg-[#F8F8F8] hover:bg-gray-100 transition-colors"
              onClick={() => setStep("email")}
            >
              E-Mail
            </button> */}
          </div>
        )}
        {step === "whatsapp" && (
          <div className="flex flex-col items-center justify-center w-full">
            <h2 className="text-center text-lg font-semibold text-[#959FA8] mb-6">
              Enter the details to share.
            </h2>
            <div className="flex justify-center items-start space-x-2 w-[220px]">
              <input
                type="text"
                readOnly
                value="+965"
                className="w-16 px-2 border border-gray-300 rounded-md text-center text-base font-semibold text-gray-700 bg-gray-100 focus:outline-none h-10"
              />
              <div className="flex-1 relative pb-8">
                <input
                  type="tel"
                  placeholder="55992092"
                  value={phoneNumber}
                  onChange={e => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");
                    setPhoneNumber(numericValue);
                    setPhoneNumberError("");
                  }}
                  className="w-full py-2 px-2 border border-gray-300 rounded-md text-base font-semibold text-gray-700 focus:outline-none focus:border-blue-400 h-10"
                />
                {phoneNumberError && (
                  <p className="text-red-500 text-xs absolute bottom-0 left-0">
                    {phoneNumberError}
                  </p>
                )}
              </div>
            </div>
            <button
              onClick={handleSend}
              className="w-[180px] mt-4 py-2 bg-[#86604D] text-white font-semibold text-base rounded-md hover:opacity-90 transition-opacity"
            >
              Send
            </button>
          </div>
        )}
        {step === "email" && (
          <div className="flex flex-col items-center justify-center w-full">
            <h2 className="text-center text-lg font-semibold text-[#959FA8] mb-6">
              Enter the details to share.
            </h2>
            <div className="flex flex-col w-[220px] relative pb-8">
              <input
                type="email"
                placeholder="candogan@seazengroup.com"
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                  setEmailError("");
                }}
                className="w-full py-2 px-2 border border-gray-300 rounded-md text-base font-semibold text-gray-700 focus:outline-none focus:border-blue-400 h-10"
              />
              {emailError && (
                <p className="text-red-500 text-xs absolute bottom-0 left-0">
                  {emailError}
                </p>
              )}
            </div>
            <button
              onClick={handleSend}
              className="w-[180px] mt-4 py-2 bg-[#86604D] text-white font-semibold text-base rounded-md hover:opacity-90 transition-opacity"
            >
              Send
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareBankDetailsModal;